import { observable, action } from 'mobx'
import PayActions from '@/actions/Pay'
import ServiceActions from '@/actions/Service'

class CommonStore {
  @observable userInfo
  @observable isLoading = false // 로딩 중 state
  @observable navStep = 0
  @observable hasSite = false
  @observable hasBill = false
  @observable confirmTrial = false
  @observable confirmDrive = false // 2023-11-01 추가 (drive 요금제)
  @observable confirmBasic = false
  @observable confirmPlus = false
  @observable confirmPromotion = false
  @observable close30dGuide = false
  @observable cashStatus = ''

  @action
  setUserInfo(userInfo) {
    this.userInfo = userInfo
  }

  @action
  setLoading = isLoading => {
    this.isLoading = isLoading
  }

  @action
  setNavStep(navStep) {
    window.sessionStorage.setItem('navStep', navStep)
    this.navStep = navStep
  }

  @action
  setHasSite(hasSite) {
    window.sessionStorage.setItem('hasSite', hasSite)
    this.hasSite = hasSite
  }

  @action
  setHasBill(hasBill) {
    window.sessionStorage.setItem('hasBill', hasBill)
    this.hasBill = hasBill
  }

  @action
  setNavStepRefresh() {
    this.navStep = window.sessionStorage.getItem('navStep')
  }

  @action
  setHasSiteRefresh() {
    this.hasSite = window.sessionStorage.getItem('hasSite')
  }

  @action
  setHasBillRefresh() {
    this.hasBill = window.sessionStorage.getItem('hasBill')
  }

  @action
  setCashStatus(status) {
    this.cashStatus = status
  }

  @action
  async getMySiteStatus() {
    let confirmTrial = false
    let confirmDrive = false // 2023-11-01 추가 (drive 요금제)
    let confirmBasic = false
    let confirmBasicPlus = false
    let confirmPlus = false
    let confirmPlusPlus = false
    let confirmPromotion = false

    const serviceList = await ServiceActions.getMyServiceList(
      sessionStorage.getItem('product')
    )

    if (serviceList === null) {
      const myServiceBill = await PayActions.getMyServiceBill(
        sessionStorage.getItem('product')
      )
      if (myServiceBill.length >= 1) {
        confirmTrial = false
      } else {
        const result = await PayActions.checkPromotionTrial(
          sessionStorage.getItem('product')
        )
        if (
          result.status === 'IMPOSSIBLE' ||
          result.status === 'EXIST' ||
          result.status === 'T_APPLY' ||
          result.status === 'T_USED' ||
          result.status === ''
        ) {
          confirmTrial = false
        } else {
          confirmTrial = true
        }
      }
      confirmDrive = true
      confirmBasic = true
      confirmBasicPlus = true
      confirmPlus = true
      confirmPlusPlus = true
      confirmPromotion = true
    } else {
      if (serviceList.length > 0) {
        if (serviceList[0].billType === 'TRIAL') {
          confirmDrive = true
          confirmBasic = true
          confirmBasicPlus = true
          confirmPlus = true
          confirmPlusPlus = true
          confirmPromotion = true
        }

        if (serviceList[0].billType === 'PAY') {
          confirmPromotion = true
        }

        if (serviceList[0].billType === 'PROMOTION') {
          confirmDrive = true
          confirmBasic = true
          confirmBasicPlus = true
          confirmPlus = true
          confirmPlusPlus = true
          confirmPromotion = true
        }
      }
    }

    this.confirmTrial = confirmTrial
    this.confirmDrive = confirmDrive
    this.confirmBasic = confirmBasic
    this.confirmBasicPlus = confirmBasicPlus
    this.confirmPlus = confirmPlus
    this.confirmPlusPlus = confirmPlusPlus
    this.confirmPromotion = confirmPromotion
  }

  @action
  setClose30dGuide(close30dGuide) {
    this.close30dGuide = close30dGuide
  }
}

export default CommonStore



// WEBPACK FOOTER //
// ./src/stores/Common.js